export default function Extras() {
  return (
    <section id="extras" className="services section section-dark">
      <div className="container">
        <div className="section-header text-center">
          <div className="section-badge">Разовые задачи</div>
          <h2>Закрытие локальных задач: верстка, скрипты, оптимизация</h2>
          <p className="description">
            Помогаю с решением срочных или сложных проектных задач.
          </p>
          <p className="description">
            Работаю от 1 500 ₽/час.
          </p>
        </div>

        {/* Группа 1: Фронтенд-разработка */}
        <div className="service-block">
          <div>
            <div className="text-content">
              <div className="section-badge">Фронтенд-разработка</div>
              <h3>Превращаю готовый дизайн в чистый и быстрый код.</h3>
              <ul className="benefits-list">
                {/* Изменения: Убрали точку с запятой, сделали описание более "продающим" */}
                <li><span className="checkmark">✓</span> Pixel-perfect верстка по макетам.</li>
                <li><span className="checkmark">✓</span> Чистый HTML5/CSS3/JS</li>
                <li><span className="checkmark">✓</span> Бесшовная интеграция верстки в ваш проект на React.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Группа 2: Техническая помощь */}
        <div className="service-block">
          <div>
            <div className="text-content">
              <div className="section-badge">Техническая помощь</div>
              <h3>Расширения функционала.</h3>
              <ul className="benefits-list">
                {/* Изменения: Добавили конкретики и выгоды */}
                <li><span className="checkmark">✓</span> Автоматизация рутинных задач.</li>
                <li><span className="checkmark">✓</span> Разработка кастомных скриптов.</li>
                <li><span className="checkmark">✓</span> Создание переиспользуемых компонентов.</li>
                <li><span className="checkmark">✓</span> Гибкая интеграция с внешними сервисами {'(API)'}.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Группа 3: Реанимация проекта */}
        <div className="service-block bg-gray-800">
          <div>
            <div className="text-content">
              <div className="section-badge">Реанимация проекта</div>
              <h3>Аудит и ускорение сайта для улучшения видимости</h3>
              <ul className="benefits-list">
                {/* Изменения: Убрали скобки, сделали текст более уверенным */}
                <li><span className="checkmark">✓</span> Рост позиций в поиске {'(Google, Яндекс)'} за счет технических улучшений.</li>
                <li><span className="checkmark">✓</span> Снижение показателя отказов: клиенты не уходят из-за медленной загрузки.</li>
                {/* <li><span className="checkmark">✓</span> Достижение отличных показателей Core Web Vitals (CWV).</li> */}
              </ul>
            </div>
          </div>
        </div>
        {/* Блок 6: Запуск и сопровождение */}
        <div className="service-block">
          <div>
            <div className="text-content">
              <div className="section-badge">Запуск и сопровождение</div>
                <h3>Помощь с доменом, хостингом и деплоем</h3>
              <ul className="benefits-list">
                  <li><span className="checkmark">✓</span> Подбор и регистрация доменного имени.</li>
                  <li><span className="checkmark">✓</span> Профессиональная настройка хостинга и деплой {'(запуск)'} проекта.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}